window.isMobile = window.innerWidth <= 768;
document.addEventListener('DOMContentLoaded', function() {
  var isMobile = window.innerWidth <= 768;
  document.documentElement.setAttribute('data-device-type', isMobile ? 'mobile' : 'desktop');
});

const swatchLabels = document.querySelectorAll('label.swatch-input__label');

swatchLabels.forEach(label => {
  label.addEventListener('click', function() {
    this.parentNode.querySelectorAll('label').forEach(l => l.classList.remove('checked'));
    this.classList.add('checked');
    const pid = this.getAttribute('pid');
    document.getElementById("loading-spinner-box-" + pid).style.display = "block";
    const imgId = `img-${pid}`;
    const targetImg = document.getElementById(imgId);
    const variantImageSrc = this.getAttribute('variant_image');
    const variantImaageSrcset = this.getAttribute('variant_image_set');
    targetImg.onload = function() {
      document.getElementById("loading-spinner-box-" + pid).style.display = "none";
    };
    
    if (targetImg && variantImageSrc) {
      targetImg.srcset = variantImaageSrcset;
      targetImg.src = variantImageSrc;

      const nextImg = targetImg.nextElementSibling;
      nextImg.srcsetBak = nextImg.srcset;
      nextImg.srcBak = nextImg.src;
      nextImg.srcset = variantImaageSrcset;
      nextImg.src = variantImageSrc;
    }
  });
  
  label.addEventListener('mouseout', function() {
    const pid = this.getAttribute('pid');
    const imgId = `img-${pid}`;
    const targetImg = document.getElementById(imgId);
    const nextImg = targetImg.nextElementSibling;
    if (nextImg.srcBak) {
      nextImg.srcset = nextImg.srcsetBak;
      nextImg.src = nextImg.srcBak;
      nextImg.srcsetBak = null;
      nextImg.srcBak = null;
    }
  });
});
